/* DO NOT EDIT BY HAND — regenerate with `npx nx run @atbash-labs/devops-resource-types:generate`. */

export const GENERATED_SCADA_RESOURCE_TYPES = ['ignition', 'aveva'] as const
export const GENERATED_PLC_RESOURCE_TYPES = ['rockwell', 'mitsubishi'] as const
export const GENERATED_DEVOPS_RESOURCE_TYPES = [
  ...GENERATED_SCADA_RESOURCE_TYPES,
  ...GENERATED_PLC_RESOURCE_TYPES
] as const

export type ScadaResourceType = (typeof GENERATED_SCADA_RESOURCE_TYPES)[number]
export type PlcResourceType = (typeof GENERATED_PLC_RESOURCE_TYPES)[number]
export type DevopsResourceType = (typeof GENERATED_DEVOPS_RESOURCE_TYPES)[number]
